import e from"react";import{AlgoliaApiKeyContext as r}from"./AlgoliaApiKeyContext.js";const o=({children:o,...t})=>e.createElement(r.Provider,{value:t},o);export{o as AlgoliaApiKeyContextProvider};
